import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconSquare = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 16H5V5h14v14z" }, void 0) }, void 0));
const Memo = memo(SvgIconSquare);
export default Memo;
//# sourceMappingURL=IconSquare.js.map